import { cn } from '@/utils/tailwind-util';
import { XIcon } from '@heroicons/react/solid/index';
import React from 'react';

import { IconButton } from '@/components/Button';

import type { ModalLayerProps } from './_ModalLayer';

const layerSizeStyle = (size: ModalLayerProps['size']) => {
  switch (size) {
    case 'auto':
      return 'w-auto min-w-80';
    case 'md':
      return 'w-full max-w-md';
    case 'lg':
      return 'w-full max-w-lg';
    case 'xl':
      return 'w-full max-w-xl';
    default:
      throw new TypeError(
        `Expected size 'auto' or 'md' or 'lg' or 'xl', but received ${size}`
      );
  }
};

const _SideModalLayer = React.forwardRef<HTMLDivElement, ModalLayerProps>(
  ({ size, hasCloseButton, hasDefaultPadding, onClose, children }, ref) => {
    return (
      <div
        className={cn(
          'relative inline-block h-screen overflow-visible text-left align-middle transition-all transform bg-white shadow-xl',
          hasDefaultPadding ? 'p-8' : 'p-0',
          layerSizeStyle(size)
        )}
        ref={ref}
      >
        {children({ onClose })}
        {hasCloseButton && (
          <div className="inline-block absolute top-[1.125rem] right-6">
            <IconButton
              size="md"
              label="close"
              iconElement={<XIcon />}
              onClick={onClose}
            />
          </div>
        )}
      </div>
    );
  }
);

_SideModalLayer.displayName = '_SideModalLayer';

_SideModalLayer.defaultProps = {
  size: 'md',
  hasCloseButton: false,
  hasDefaultPadding: true,
};

export default _SideModalLayer;
